const baseFitmentFields = ['Year', 'Make', 'Model', 'Submodel'];
const extraFitmentFields = [];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern_mm'];
const tiresFields = ['tire_width', 'tire_aspect', 'tire_rim'];
// ignore submodel for accessories page where we search only by YMM
const ignoreFields = [...wheelsFields, ...tiresFields];

const isOnPDP = window.document.querySelector('body.page--product');

function getFitmentSearchTitle() {
  const breadcrumbNames = [...window.document.querySelectorAll('ol.breadcrumbs .breadcrumb span')].map(
    (el) => el.textContent,
  );

  return window.location.pathname.includes('/shop-by-category')
    ? 'Collections'
    : window.location.pathname.includes('/brands')
      ? 'Brands'
      : breadcrumbNames.includes('Tires')
        ? 'Tires'
        : breadcrumbNames.includes('Wheels')
          ? 'Wheels'
          : 'Parts';
}

const getLocalPreselection = () => [{ field: 'not_out_of_stock', term: 'True' }];

// hide verifyVerifyFitment widget on "Apparel & More", "ATV-UTV Wheels" and "ATV-UTV" tire
// which are "No Fitment Data"
const hideVerifyFitmentBreadcrumbs = ['Tires', 'Wheels', 'Apparel & More'];
window.Convermax.hideUnknownVerifyFitment = () =>
  [...window.document.querySelectorAll('ul.breadcrumbs .breadcrumb span')]
    .map((b) => b.textContent)
    .some((el) => hideVerifyFitmentBreadcrumbs.includes(el));

window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );

  const compareButton = window.document.body.querySelector('.cm_card-compare');

  if (!compareButton) {
    return;
  }

  const compareLink = window.document.body.querySelector('.cm_card-compare_link');
  const compareCount = window.document.body.querySelector('.cm_card-compare_count');

  compareCount.textContent = productsIdsToCompare.length;
  compareButton.classList.toggle('show', productsIdsToCompare.length > 1);
  compareLink.href = `/compare/${productsIdsToCompare.join('/')}/`;
};

const pdpProductCategory = window.document.querySelector(
  '.productView-options input[name="product_category"]',
)?.value;
const isWheelCategoryProduct =
  pdpProductCategory?.includes('Wheel') && !pdpProductCategory?.includes('ATV-UTV WHEELS');
const verifyFitmentDialogOpenedClass = 'cm_verify-dialog-opened';

window.Convermax.openVerifyFitmentDialog = (e) => {
  if (isWheelCategoryProduct && !window.Convermax.isVehicleSelected()) {
    e.preventDefault();
    e.stopPropagation();

    window.document.body.classList.add(verifyFitmentDialogOpenedClass);
    window.Convermax.openDialog('VehicleWidgetDialog');
  }
};

const onVehicleSelected = () => {
  if (isWheelCategoryProduct && window.document.body.classList.contains(verifyFitmentDialogOpenedClass)) {
    window.document.body.classList.remove(verifyFitmentDialogOpenedClass);

    const addToCartBtn = window.document.querySelector('#form-action-addToCart');
    if (addToCartBtn) {
      window.document.querySelector('#cm_VehicleWidgetDialog .close')?.click();

      setTimeout(() => {
        addToCartBtn.click();
      }, 200);
    }
  }
};

export default {
  platform: 'bigcommerce',
  searchPageUrl: '/pages/search',
  getLocalPreselection,
  SearchRequestDefaults: {
    pageSize: 30,
  },
  autocomplete: {
    fields: ['not_out_of_stock'],
  },
  pagination: {
    centralRange: 1,
    edgeRange: 1,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: '/shop-by-category', field: 'category' },
      { pathname: '/brands', field: 'brand_name' },
    ],
    categorySelectionPageRedirect: true,
    isAutoRedirectDisabled: true,
    isAutoVehicleSelectionDisabled: !isOnPDP,
    isVehicleSelectionIsolated: true,
    isExtraFieldsAlwaysVisible: true,
    getFitmentSearchTitle,
    onVehicleSelected,
  },
  facets: {
    rangedFacet: [
      { fields: ['wheel_frontspacing', 'wheel_backspacing'], step: '1/100' },
      { fields: ['wheel_load'], step: '10//1' },
      { fields: ['tire_load_index'], slider: { mode: 'LowerBound' } },
      { fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } },
    ],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        lastChildOf: 'body.page--category .page-content:not(.page-content-brand-logo-listing)',
        class: 'cm_SearchPage__category',
      },
      template: 'MainContent',
    },
    {
      name: 'BrandPage',
      type: 'SearchPage',
      location: 'body.page--brand .page',
      template: 'SearchPage',
    },
    {
      name: 'CategoryFacetPanel',
      type: 'SearchPage',
      location: {
        replace: 'body.page--category aside.page-sidebar',
        class: 'page-sidebar cm_FacetPanel__category',
      },
      template: 'FacetPanelContainer',
      ignoreFields,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FilterChips__mobile',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
      initCollapsed: true,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    {
      name: 'SearchResult',
      infiniteScrollDisabled: true,
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'name': 'Alphabetical: A to Z',
        'name:desc': 'Alphabetical: Z to A',
        'price': 'Price: Low to High',
        'price:desc': 'Price: High to Low',
      },
    },
    {
      name: 'SearchBox',
      location: '.header__search .container',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '#quick-search-expand',
        class: 'cm-mobile-search-box',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        selector: 'section.partFinder .partFinder__tireFinder',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysColumnLayout: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 500,
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.header__main .header__main-actions .cart-icon',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: 'body.page--product .productView-options form',
      },
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 600,
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: {
        selector: '#cm-category-list',
        class: 'cm_vehicle-categories__category',
      },
      template: 'facetTiles/hierarchicalContainer',
      columnBreakpoint: 500,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      columnBreakpoint: 500,
    },
    {
      name: 'TirePanelMetric_tab',
      type: 'RequestPanel',
      location: {
        selector:
          'section.partFinder .partFinder__tireFinder + .partFinder__tireFinder + .partFinder__tireFinder',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeTabRequestPanel',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      selectFields: tiresFields,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: {
        selector: 'section.partFinder .partFinder__tireFinder + .partFinder__tireFinder',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeTabRequestPanel',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      selectFields: wheelsFields,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect: isOnPDP,
    },
  ],
};
